import { render, staticRenderFns } from "./PsPatientSubscriptionDetail.vue?vue&type=template&id=7abb4054&scoped=true&"
import script from "./PsPatientSubscriptionDetail.vue?vue&type=script&lang=js&"
export * from "./PsPatientSubscriptionDetail.vue?vue&type=script&lang=js&"
import style0 from "./PsPatientSubscriptionDetail.vue?vue&type=style&index=0&id=7abb4054&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7abb4054",
  null
  
)

export default component.exports